<sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">
  <sc-flex-fitting-content [vertical]="true">
    <sc-scroll-pane>
      <sc-read-only-field
        [label]="'Priorität'| translate:['tmc-yard.entity.moving-order.priority', translationService.language]"
        [value]="movementOrderDetails?.priority ? 'Ja' : 'Nein'"></sc-read-only-field>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <sc-read-only-field
        [label]="'Referenzdatum'| translate:['tmc-yard.entity.moving-order.referenceDate', translationService.language]"
        [value]="movementOrderDetails?.referenceDate | date:'dd.MM.yy H:mm'"></sc-read-only-field>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <sc-read-only-field
        [label]="'Umfang'| translate:['tmc-yard.entity.moving-order.scope', translationService.language]"
        [value]="movementOrderDetails?.scope"></sc-read-only-field>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <sc-read-only-field
        [label]="'Transportmerkmal'| translate:['tmc-yard.entity.moving-order.identifier', translationService.language]"
        [value]="movementOrderDetails?.identifier"></sc-read-only-field>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <sc-read-only-field
        [label]="'akt. Station'| translate:['tmc-yard.entity.moving-order.currentStation', translationService.language]"
        [value]="movementOrderDetails?.currentStation"></sc-read-only-field>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <sc-read-only-field
        [label]="'Ziel'| translate:['tmc-yard.entity.moving-order.targetStation', translationService.language]"
        [value]="movementOrderDetails?.targetStation"></sc-read-only-field>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <sc-read-only-field
        [label]="'Transportreferenz'| translate:['tmc-yard.entity.moving-order.transportReference', translationService.language]"
        [value]="movementOrderDetails?.transportReference"></sc-read-only-field>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <sc-read-only-field
        [label]="'Bearbeitungsstatus'| translate:['tmc-yard.entity.moving-order.processingStatus.label', translationService.language]"
        [value]="movementOrderDetails?.processingStatus ? (movementOrderDetails?.processingStatus | translate:['tmc-yard.entity.moving-order.processingStatus.' + movementOrderDetails?.processingStatus,
                  translationService.language]) : ''"></sc-read-only-field>
    </sc-scroll-pane>
  </sc-flex-fitting-content>
  <sc-content-spacer [vertical]="true" *ngIf="responseMessages.length>0"></sc-content-spacer>
  <app-service-response [responseMessages]="responseMessages"></app-service-response>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <div>
    <sc-flex>
      <button mat-stroked-button (click)="cancel()" [disabled]="!cancelEnabled || loading">
        Stornieren
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button (click)="handleStatusChangeReverse()"
        [disabled]="!statusChangeReverseButtonEnabled || loading">
        Zurück
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="handleStatusChange()" [disabled]="!statusChangeButtonEnabled || loading"
        *ngIf="statusChangeButtonVisible">
        {{statusChangeLabel| translate:[statusChangeLabel, translationService.language]}}
      </button>
    </sc-flex>
  </div>
</sc-flex>